"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["label", "children", "className"];
var SearcherFormField = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var label = _ref.label,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledSearcherFormField, (0, _extends2["default"])({
    className: className
  }, props), /*#__PURE__*/_react["default"].createElement(StyledLabel, null, label), children);
});
SearcherFormField.displayName = 'SearcherFormField';
var StyledSearcherFormField = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormField__StyledSearcherFormField",
  componentId: "sc-fbb13r-0"
})([""]);
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormField__StyledLabel",
  componentId: "sc-fbb13r-1"
})(["font-size:9px;color:", ";text-transform:uppercase;margin-bottom:6px;"], function (props) {
  return props.theme.colors.blackLight;
});
var _default = exports["default"] = SearcherFormField;